export default "__VITE_ASSET__B$mrl8xG__"